var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"task-item",attrs:{"type":"inner"}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }